// IntroContent.js

import React from "react";
import {
    FaGithub,
    FaLinkedin,
    FaEnvelope,
    FaCode,
    FaHackerrank,
} from "react-icons/fa"; // Import icons

import sandesh from "../../../images/sandesh1.jpg";
// import CallToAction from "../../shared/CallToAction";
// import { scrollToSection } from "../../utils/helpers";

import "./style.scss";

const IntroContent = () => {
    return (
        <div className="intro-content">
            <div className="layout">
                <div className="left-col">
                    <h1 className="title">
                        <span className="small-text">
                            <span className="text">HEY THERE !</span>
                            <span className="icon"></span>
                            <span className="text">I AM</span>
                        </span>
                        
                        <span className="big-text" >SANDESH BHUJBAL</span>
                    </h1>

                    <div className="title1">
                        CODER, DEVELOPER, AND ACTIVE LEARNER
                    </div>

                    <div className="social-icons">
                        <a href="mailto:bhujbalsandesh52@gmail.com">
                            <FaEnvelope className="icon" />
                        </a>
                        <a
                            href="https://github.com/sandesh300"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaGithub className="icon" />
                        </a>
                        <a
                            href="https://www.linkedin.com/in/sandesh-bhujbal-b3a16a222/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaLinkedin className="icon" />
                        </a>
                        <a
                            href="https://leetcode.com/sandesh_30/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaCode className="icon" />
                        </a>
                        <a
                            href="https://www.hackerrank.com/profile/bhujbalsandesh52"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaHackerrank className="icon" />
                        </a>
                    </div>
                </div>
                <div className="right-col">
                    <img
                        src={sandesh}
                        alt="Hello I am Sandesh Bhujbal"
                    />
                </div>
            </div>
        </div>
    );
};

export default IntroContent;
